import { Pencil, Trash2 } from "lucide-react";

export default function EntitiesTable({ entities = [], onEdit, onDelete }) {
  console.log("📊 EntitiesTable received:", entities);  // Log the entities prop
  
  if (!entities?.length) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-gray-500">No entities found</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-3 text-left font-medium text-gray-600">ID</th>
            <th className="p-3 text-left font-medium text-gray-600">Name</th>
            <th className="p-3 w-24 text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {entities.map((e) => (
            <tr key={e.id} className="border-t border-gray-100 hover:bg-gray-50">
              <td className="p-3 text-gray-600">{e.id}</td>
              <td className="p-3">{e.name}</td>
              <td className="p-3 flex justify-end gap-2">
                <button 
                  onClick={() => onEdit(e)}
                  className="p-1 hover:bg-gray-100 rounded"
                  title="Edit entity"
                >
                  <Pencil size={16} className="text-blue-600"/>
                </button>
                <button 
                  onClick={() => onDelete(e.id)}
                  className="p-1 hover:bg-gray-100 rounded"
                  title="Delete entity"
                >
                  <Trash2 size={16} className="text-red-600"/>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}